export default {
  vendas: `vendas`,
  liberado: `Liberado`,
  cod: `Cód.`,
  ativo: `Ativo`,
  verificada: `Verificada`,
  habilitado: `Habilitado`,
  selecionados: `Selecionado(s)`,
  totalvendas: `Total de vendas`,
  lancamentos: `Lançamentos`,
  totalPagarEC: `Total à pagar EC`
};
